export { MailOpen as default } from './MailOpen';
